export const SET_ERROR = 'SET_ERROR' as const
export const CLEAR_ERROR = 'CLEAR_ERROR' as const
